import { SuspensePage } from '@/shared/ui/layout/SuspensePage';
import { PagesParcelClaimMain } from './modules/ui/Main';

const ParcelClaimPage = (
  <SuspensePage>
    <PagesParcelClaimMain />
  </SuspensePage>
);

export default ParcelClaimPage;
